// extracted by mini-css-extract-plugin
module.exports = {"holder":"contactInfo_holder__1OuA0","image":"contactInfo_image__1gc91","link":"contactInfo_link__36s_x"};